import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

@doc.path('/plan_analyses/{id}/preview')
export default class PlanAnalysisPreviewModel extends MapServiceModel {
}
